import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useLocation } from 'react-router-dom';
export function useLocationWithState() {
    const location = useLocation();
    return _object_spread_props(_object_spread({}, location), {
        state: location.state
    });
}
